import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('SET_REMINDER_SOUND_ENABLED', function (isEnabled) {
    getStore().reminderSound = isEnabled;
});
//# sourceMappingURL=setReminderSoundEnabled.js.map